<template>
  <div data-testid="queries-list">
    <div class="all-height d-flex justify-center" data-testid="queries-list__container">
      <div class="all-width" data-testid="queries-list__content">
        <v-card class="shadow-off" :loading="loading" :disabled="loading" loader-height="2" data-testid="queries-list__card">
          <v-card-text class="pb-0" data-testid="queries-list__card-text">
            <div class="d-flex align-center">
              <v-btn  v-if="$nova.hasRight(right, 'add')" rounded color="primary" @click="queriesDilog = true;queriesObject = {};error = {}; " elevation="0" class="mr-2 white--text" data-testid="queries-list__new-btn">
                <v-icon class="mr-1">mdi-plus</v-icon><span>New</span>
              </v-btn>
              <v-btn icon @click="refreshData()" data-testid="queries-list__refresh-btn"><v-icon>mdi-refresh</v-icon></v-btn>
              <v-spacer></v-spacer>
              <lb-string label="Search" outlined hidedetails v-model="seachList" data-testid="queries-list__search-input"></lb-string>
            </div>
          </v-card-text>
          <v-card-text data-testid="queries-list__table-card-text">
            <v-data-table class="FC-Table border-on radius-small" :headers="queriesHeader" :items="queriesData" hide-default-footer dense :items-per-page="-1"
              :search="seachList" data-testid="queries-list__data-table" >
              <template #[`item.no`]="{ item, index }">
                <tr class="tableHeaderbg" data-testid="queries-list__table-row">
                  <td data-testid="queries-list__table-row-number">{{ index + 1 }}</td>
                </tr>
              </template>

              <template v-slot:[`item.stage`]="{ item }">
                <div class="text-center" data-testid="queries-list__stage-chip">
                  <v-chip small label v-if="item.stage === 1" color="lightgreen" class="teal--text" data-testid="queries-list__stage-chip-closed"><span>Close</span></v-chip>
                  <v-chip small label v-else color="lightblue" class="Tabblue--text" data-testid="queries-list__stage-chip-open"><span>Open</span></v-chip>
                </div>
              </template>
              <template v-slot:[`item.type`]="{ item }">
                <div class="text-center" data-testid="queries-list__type-chip">
                  <v-chip small label v-if="item.type === 'technical'" color="" data-testid="queries-list__type-chip-technical"><span>Technical</span></v-chip>
                  <v-chip small label v-else-if="item.type === 'functional'" color="" data-testid="queries-list__type-chip-functional"><span>Functional</span></v-chip>
                  <v-chip small label v-else data-testid="queries-list__type-chip-na"><span>NA</span></v-chip>
                </div>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex align-center justify-center" data-testid="queries-list__actions">
                  <v-btn @click="
                    $nova.gotoLink({ path: 'support/' + item._id })
                  " class="view-on-hover-item-d mx-0 px-0" icon data-testid="queries-list__view-btn"><v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <Conversation heading="Conversation" width="600" :loading="loading" :recurring="true"
                    :recurringText="recurringContent" :notify="false" :projectid="item._id" :getApi="getURL"
                    :sendApi="sendURL" data-testid="queries-list__conversation" />
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-dialog v-model="queriesDilog" max-width="600" persistent data-testid="queries-list__dialog">
      <v-card class="" :loading="queriesloading" :disabled="queriesloading" loader-height="2" data-testid="queries-list__dialog-card">
        <v-card-text class=" font-weight-bold d-flex align-center py-2 px-4" data-testid="queries-list__dialog-header">
          <span class="font-size-md font-weight-bold" v-if="queriesObject._id" data-testid="queries-list__dialog-update">Update</span>
          <span class="font-size-md font-weight-bold" v-else data-testid="queries-list__dialog-add">Add</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="queriesDilog = false" class="ml-2 " data-testid="queries-list__dialog-close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-4 pt-4">
          <v-row>
            <v-col cols="12" class="my-0 py-0" >
              <lb-string label="Request" :isRequired="true" v-model="queriesObject.issue" :error="errors['issue']" data-testid="queries-list__dialog-request" />
            </v-col>
            <v-col cols="12" class="my-0 py-0">
              <lb-textarea v-model="queriesObject.description" label="Description"
                :error="errors['description']" data-testid="queries-list__dialog-description" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="d-flex">
          <v-spacer></v-spacer>
          <v-btn color="fbcPrimary"  class="white--text" v-if="queriesObject._id" @click="productUpdate()" data-testid="queries-list__dialog-update"><span>Update</span></v-btn>
          <v-btn color="fbcPrimary" class="white--text" v-else @click="createQuerie()" data-testid="queries-list__dialog-create"><span>Create</span></v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Conversation from "../common/Conversation.vue";
export default {
  name: "helpdesk_list",
  data() {
    return {
      right: "helpdesk",
      getURL: "/v2/bot/analysis/getbotconversation/",
      sendURL: "/v2/bot/analysis/addbotconversation",
      recurringContent: "Is it possible to append comment in requirements sdsdfs sdfsdf sdfsd asdsadawd ",
      loading: false,
      errors: {},
      queriesObject: {},
      queriesDilog: false,
      queriesloading: false,
      queriesHeader: [
        { text: "No", value: "no", sortable: false },
        { text: "Request", value: "issue", sortable: false },
        { text: "Description", value: "description", sortable: false },
        { text: "Type", value: "type", sortable: false, align: "center" },
        { text: "Stage", value: "stage", sortable: false, align: "center" },
        { text: "Action", value: "actions", sortable: false, align: "center" },
      ],
      seachList: null,
      queriesData: [],
    };
  },
  components: {
    // Conversation,
  },
  created() {
    this.refreshData();
  },
  activated() {
    this.refreshData();
  },
  props: {
    project: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    typenot: {
      type: String,
      default: "",
    },
  },
  methods: {
    refreshData() {
      this.loading = true;
      let nfltr = { modulename: this.$route.meta.modulename };
      if(this.type) nfltr.type = this.type;
      if(this.typenot) nfltr.typenot = this.typenot;
      if(this.project) nfltr.project = this.project;
      this.axios
        .post("/v2/helpdesk/queries/getqueriesbyclient", { filter: nfltr })
        .then((dt) => {
          this.queriesData = dt.data.data;
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    createQuerie() {
      this.queriesloading = true;
      // console.log(this.$route.mata.modulename, "this.$route.mata.modulename");
      this.queriesObject.modulename = this.$route.meta.modulename;
      this.axios
        .post("/v2/helpdesk/queries/add", { data: this.queriesObject })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.refreshData();
            this.$store.commit("sbSuccess", "New Query Added successfully");
            this.queriesDilog = false;
          } else {
            if (dt.data.data.length > 0) {
              if (dt.data.data[0].index0) this.errors = dt.data.data[0].index0;
            }
            throw new Error(dt.data.message || "Error Add Query");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.queriesloading = false;
        });
    },
    QuerieUpdate() {
      this.loading = true;
      this.queriesObject.modulename = this.$store.state.modulename;
      this.axios
        .post("/v2/helpdesk/queries/edit/" + this.queriesObject._id, {
          data: this.queriesObject,
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.refreshData();
            this.$store.commit("sbSuccess", "New Query Added successfully");
            this.refreshData();
            this.queriesDilog = false;
          } else {
            if (dt.data.data.length > 0) {
              if (dt.data.data[0].index0) this.errors = dt.data.data[0].index0;
            }
            throw new Error(dt.data.message || "Error Add Query");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
